import { Box, Divider, Grid, GridSize, Typography } from "@mui/material";
import {
  ItemIconBox,
  LowerContainer,
  PatientDetailsValue,
  patientNameContainer,
  patientNameTypo,
  styles,
} from "../style";
import fontWeight from "../../../styles/mui/fontWeight";
import colors from "../../../styles/colors/colors";
import { PatientHeaderFormProps } from ".";

export const PatientNameGrid = (patientName: string) => {
  return (
    <Grid sx={styles.container}>
      <Typography
        variant="h2"
        fontWeight={fontWeight.Weight[7]}
        lineHeight={"1.8rem"}
        sx={patientNameTypo}
        color={colors.fonts[18]}
      >
        <Box style={styles.lineItem}>{patientName}</Box>
      </Typography>
    </Grid>
  );
};
const PcpInfo: React.FC<PatientHeaderFormProps> = ({ getValues }: PatientHeaderFormProps) => {
  const fieldRender = (
    label: string,
    xs: GridSize,
    value: string | number | null,
    icon?: React.ReactNode,
    labelColor: string = colors.fonts[2]
  ) => {
    return (
      <Grid size={xs}>
        <Typography
          variant="body1"
          fontWeight={fontWeight.Weight[3]}
          color={labelColor}
        >
          {label}
        </Typography>
        <Box>
          {icon && value ? <Box sx={ItemIconBox}>{icon}</Box> : ""}
          <Typography
            variant="subtitle2"
            fontWeight={fontWeight.Weight[5]}
            color={colors.fonts[4]}
            sx={PatientDetailsValue}
          >
            {value}
          </Typography>
        </Box>
      </Grid>
    );
  };

  return (
    <Grid container wrap="nowrap" columnSpacing={0.5}>
      <Grid size="auto" sx={patientNameContainer}>
         {PatientNameGrid(getValues("patientName"))}
      </Grid>
      <Grid size="grow">
        <Grid container>
          <Grid size={12}>
            <Grid container>
              {fieldRender(
                "Physician Name:",
                2,
                getValues("primaryPhysician.physicianName")
              )}
              {fieldRender(
                "NPI:",
                2,
                getValues("primaryPhysician.physicianNpiId")
              )}
              {fieldRender("Tax ID:", 2, getValues("primaryPhysician.taxId"))}
              {fieldRender(
                "Phone number:",
                2,
                getValues("primaryPhysician.phoneNo")
              )}
              {fieldRender("Fax number:", 2, getValues("primaryPhysician.fax"))}
            </Grid>
          </Grid>
          <Grid size={12} pt={"1.5rem"}>
              <Divider/>
          </Grid>
          <Grid size={12} pt={"1.5rem"}>
            <Typography
              variant="h6"
              fontWeight={fontWeight.Weight[6]}
              color={colors.fonts[4]}
            >
              ADDRESS DETAILS:
            </Typography>
          </Grid>
          <Grid size={12} pt={"0.5rem"}>
            <Grid container sx={LowerContainer}>
              {fieldRender(
                "Street Name 1:",
                1.8,
                getValues("primaryPhysician.streetName1"),
                undefined,
                colors.fonts[5]
              )}
              {fieldRender(
                "Street Name 2:",
                1.8,
                getValues("primaryPhysician.streetName2"),
                undefined,
                colors.fonts[5]
              )}
              {fieldRender(
                "County:",
                1.8,
                getValues("primaryPhysician.county"),
                undefined,
                colors.fonts[5]
              )}
              {fieldRender(
                "City:",
                1.8,
                getValues("primaryPhysician.city"),
                undefined,
                colors.fonts[5]
              )}
              {fieldRender(
                "State:",
                1.8,
                getValues("primaryPhysician.physicianState"),
                undefined,
                colors.fonts[5]
              )}
              {fieldRender(
                "Zip Code:",
                1.8,
                getValues("primaryPhysician.zipCode"),
                undefined,
                colors.fonts[5]
              )}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default PcpInfo;
